import { lazy } from "react";
import { Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";

const ManualPage = lazy(() => import("../Manual"));
const ManualDetailsPage = lazy(() => import("../pages/ManualEdit"));
const ManualHistoryDetailsPage = lazy(
  () => import("../pages/ManualHistoryDetails")
);
const ManualHistoryPage = lazy(() => import("../pages/ManualHistory"));

const useManualRoutes = () => (
  <Route path={`${PATHS.Manual.Path}`}>
    <Route path="" element={<ManualPage />} />
    <Route path=":locale/:key" element={<ManualDetailsPage />} />
    <Route path=":locale/:key/history" element={<ManualHistoryPage />} />
    <Route
      path=":locale/:key/history/:version"
      element={<ManualHistoryDetailsPage />}
    />
  </Route>
);

export { useManualRoutes };
